import {
  PremiumFeaturesQuery,
  SubscriptionStatus,
} from '__generated__/atlas-types'

import { PremiumFeatureFromHook } from './components/FeatureCard'

type PremiumFeatureSubscription = NonNullable<
  PremiumFeaturesQuery['premiumFeatures']
>[0]['subscriptions'][0]

export const createFakeSubscription = (
  status: SubscriptionStatus,
): PremiumFeatureSubscription => {
  return {
    id: '',
    status,
    accountAccessCount: 0,
    frequency: '',
    expiryDate: '',
    priceId: '',
    isOwner: false,
    isTrial: false,
  }
}

const STATUS_ORDER: Record<SubscriptionStatus, number> = {
  [SubscriptionStatus.PROCESSING]: 0,
  [SubscriptionStatus.EXPIRED]: 1,
  [SubscriptionStatus.AVAILABLE_FOR_PURCHASE]: 2,
  [SubscriptionStatus.ACTIVE]: 4,
  [SubscriptionStatus.CANCELLED]: 4,
  [SubscriptionStatus.SCHEDULED]: 5,
  [SubscriptionStatus.ERROR]: 6,
  [SubscriptionStatus.UNKNOWN]: 7,
}

/**
 * note: even though we have disconnected what is shown in the card status
 * from the server status, the sorting is not affected by that
 */
export type PremiumFeaturesSortObj = Pick<
  PremiumFeatureFromHook,
  'id' | 'name'
> & {
  status?: SubscriptionStatus | null
}
export const sortPremiumFeatures = (
  a?: PremiumFeaturesSortObj | null,
  b?: PremiumFeaturesSortObj | null,
  onTopfeatureId?: string,
) => {
  // user comes back from checkout session, we want to show that feature first
  if (onTopfeatureId) {
    if (a?.id === onTopfeatureId) {
      return -1
    }
    if (b?.id === onTopfeatureId) {
      return 1
    }
  }

  const statusA: SubscriptionStatus = a?.status
    ? a?.status
    : SubscriptionStatus.AVAILABLE_FOR_PURCHASE
  const statusB: SubscriptionStatus = b?.status
    ? b?.status
    : SubscriptionStatus.AVAILABLE_FOR_PURCHASE

  const statusDiff = STATUS_ORDER[statusA] - STATUS_ORDER[statusB]
  if (statusDiff !== 0) return statusDiff

  // if within the same status, we sort a-z
  const nameA = a?.name ?? ''
  const nameB = b?.name ?? ''

  return nameA.localeCompare(nameB, undefined)
}
